<div class="myModal">
	<div class="modal-header">
		<button (click)="activeModal.dismiss()" class="close" aria-label="close">
			<span>{{ 'avis.histoRefConsult.fermer' | translate }}</span>
			<mat-icon aria-hidden="true">close</mat-icon>
		</button>
	</div>
	<div class="modal-body">
		<table class="table table-bordered table-sm mt-2 histo-table">
			<thead class="thead-light">
				<tr>
					<th>{{ 'avis.histoRefConsult.colonneAncienneRef' | translate }}</th>
					<th>{{ 'avis.histoRefConsult.colonneNouvelleRef' | translate }}</th>
					<th>{{ 'avis.histoRefConsult.colonneDateModification' | translate }}</th>
				</tr>
			</thead>
			<tbody class="histo-tbody">
				<tr *ngFor="let ligne of lignes">
					<td>{{ ligne.ancienneRef }}</td>
					<td>{{ ligne.nouvelleRef }}</td>
					<td>{{ ligne.dateHeure | date:'dd/MM/yyyy HH:mm' }}</td>
				</tr>
				<tr *ngIf="lignes.length === 0">
					<td colspan="3" class="text-center">{{ 'avis.histoRefConsult.aucuneModification' | translate }}</td>
				</tr>
			</tbody>
		</table>
	</div>
	<div class="modal-footer">
		<button (click)="activeModal.dismiss()" class="btn btn-outline-primary mr-auto" aria-label="Fermer">{{ 'avis.histoRefConsult.fermer' | translate }}</button>
	</div>
</div>
